// Photo file reading and thumbnail utilities

export interface PhotoFileData {
    imageBlob: Blob;
    thumbnailBlob: Blob;
    contentType: string;
    fileName: string;
    fileSizeBytes: number;
}

export const photoHelpers = {
    async readPhotoFile(inputElement: HTMLInputElement, thumbnailSize: number = 300): Promise<PhotoFileData | null> {
        if (!inputElement?.files?.length) {
            return null;
        }

        const file = inputElement.files[0];
        
        try {
            const thumbnailBlob = await createThumbnailBlob(file, thumbnailSize, thumbnailSize);
            inputElement.value = '';
            
            return {
                imageBlob: file,
                thumbnailBlob,
                contentType: file.type || 'image/jpeg',
                fileName: file.name,
                fileSizeBytes: file.size
            };
        } catch (error) {
            console.error('[PhotoHelpers] Error reading file:', error);
            return null;
        }
    },

    async createThumbnailBlob(imageBlob: Blob, maxWidth: number, maxHeight: number): Promise<Blob> {
        return await createThumbnailBlob(imageBlob, maxWidth, maxHeight);
    }
};

async function createThumbnailBlob(imageSource: Blob, maxWidth: number, maxHeight: number): Promise<Blob> {
    const imageBitmap = await createImageBitmap(imageSource);
    
    const size = Math.min(imageBitmap.width, imageBitmap.height);
    const sx = (imageBitmap.width - size) / 2;
    const sy = (imageBitmap.height - size) / 2;

    const canvas = new OffscreenCanvas(maxWidth, maxHeight);
    const ctx = canvas.getContext('2d');
    if (!ctx) {
        throw new Error('Could not get canvas context');
    }

    ctx.drawImage(imageBitmap, sx, sy, size, size, 0, 0, maxWidth, maxHeight);
    imageBitmap.close();
    
    return await canvas.convertToBlob({ type: 'image/webp', quality: 1.0 });
}
